<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loading">
                    <data-table :headings="supervisorHeadings" :data="depotSupervisors" :hasActions="true" 
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onDepotSupervisorActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button class="btn btn-primary" @click="onAddDepotSupervisorClick">Add Depot Supervisor</button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                               :componentId="'customerFilterRadioButtons'"
                                                               @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <mark-as-active-inactive-modal
                :heading="depotSupervisorMarkAsActiveInactiveModal.heading"
                :modalId="depotSupervisorMarkAsActiveInactiveModal.modalId"
                :isSaving="depotSupervisorMarkAsActiveInactiveModal.isSaving"
                :showModal="depotSupervisorMarkAsActiveInactiveModal.showModal"
                :isActive="depotSupervisorMarkAsActiveInactiveModal.isActive"
                @closeClicked="depotSupervisorMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>

    <modal-form
            :heading="depotSupervisorAddOrEditModal.heading"
            :modalId="depotSupervisorAddOrEditModal.modalId"
            :isSaving="depotSupervisorAddOrEditModal.isSaving"
            :showModal="depotSupervisorAddOrEditModal.showModal"
            @closeClicked="onDepotSupervisorAddOrEditModalCloseClicked"
            @saveButtonClicked="onAddOrEditDepotSupervisorSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="firstNameInput">
                        First Name
                    </label>
                    <div class="text-danger" v-if="depotSupervisorAddOrEditModal.depotSupervisor.firstName.hasError">
                        {{depotSupervisorAddOrEditModal.depotSupervisor.firstName.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="firstNameInput" v-model="depotSupervisorAddOrEditModal.depotSupervisor.firstName.value"/>
                </div>
                <div class="form-group">
                    <label for="lastNameInput">
                        Last Name
                    </label>
                    <div class="text-danger" v-if="depotSupervisorAddOrEditModal.depotSupervisor.lastName.hasError">
                        {{depotSupervisorAddOrEditModal.depotSupervisor.lastName.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="lastNameInput" v-model="depotSupervisorAddOrEditModal.depotSupervisor.lastName.value"/>
                </div>
                <div class="form-group">
                    <label for="emailInput">
                        Email Address
                    </label>
                    <div class="text-danger" v-if="depotSupervisorAddOrEditModal.depotSupervisor.emailAddress.hasError">
                        {{depotSupervisorAddOrEditModal.depotSupervisor.emailAddress.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="emailInput" v-model="depotSupervisorAddOrEditModal.depotSupervisor.emailAddress.value"/>
                </div>
                <div class="form-group form-check" v-if="depotSupervisorAddOrEditModal.depotSupervisor.isUpdate">
                    <input class="form-check-input" type="checkbox" value="" id="resetPasswordCheckbox" v-model="depotSupervisorAddOrEditModal.depotSupervisor.resetPassword">
                    <label class="form-check-label" for="resetPasswordCheckbox">
                        Reset Password
                    </label>
                </div>
                <div class="text-danger" v-if="depotSupervisorAddOrEditModal.depotSupervisor.password.hasError">
                    {{depotSupervisorAddOrEditModal.depotSupervisor.password.errorMessage}}
                </div>
                <password-generator @passwordGenerated="onPasswordGeneratedAddOrEdit" v-if="!depotSupervisorAddOrEditModal.depotSupervisor.isUpdate || depotSupervisorAddOrEditModal.depotSupervisor.resetPassword"></password-generator>
            </form>
        </template>
    </modal-form>
    
    <password-generator-modal
                :modalId="userPasswordResetModal.modalId"
                :userId="userPasswordResetModal.userId"
                :showModal="userPasswordResetModal.showModal"
                :username="userPasswordResetModal.username"
                @passwordGeneratorOkClicked="onPasswordGeneratorOkClicked"></password-generator-modal>
</div>
